import { Box } from 'reflexbox';
import styled, { keyframes } from 'styled-components';

const animation = keyframes`
    0% { opacity: 0; transform: translate(-50%, -50%) scale(3, 3); }
    99% { opacity: 1; transform: translate(-50%, -50%); }
    100% { opacity: 0; }
`;

const Digit = styled(Box)`
	position: absolute;
	top: 50%;
	left: 50%;
	font-size: 16px;
	transform: translate(-50%, -50%);
	color: white;
	opacity: 0;
	animation: 1s cubic-bezier(0, 1, 0, 1) ${animation};
	animation-fill-mode: forwards;
	font-weight: bold;
`;

export default function VoiceMemoCountdown() {
	return (
		<>
			<Digit>3</Digit>
			<Digit style={{ animationDelay: '1s' }}>2</Digit>
			<Digit style={{ animationDelay: '2s' }}>1</Digit>
		</>
	);
}
